module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'rightProjects'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'rightProjects'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.rightProjects.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'mostImportant'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'mostImportant'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.mostImportantFirst.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'rightProjects'),
      expression: "selectedItem === 'rightProjects'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.rightProjects.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[0])) + " til " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[1])) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.rightProjects.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.rightProjects.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerRevenue"
    }
  }), _vm._v("\n                    Arbejdes der med de rigtige opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.rightProjectsColumns,
      "rows": _vm.data.right_projects.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsLearning', 'projectTypeRevenue')
      }
    }
  }, [_vm._v("\n                Gå til alle opgavetyper →\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mostImportant'),
      expression: "selectedItem === 'mostImportant'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.mostImportantFirst.tykTekst1) + "\n            "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px",
      "font-weight": "normal"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.projectsMostImportantRange[0].name) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[0].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_per_hour_change))))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[0].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green",
      "margin-left": "10px"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red",
      "margin-left": "10px"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_change))))])])]), _vm._v(" "), (_vm.projectsMostImportantRange.lenght > 1) ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px",
      "font-weight": "normal"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.projectsMostImportantRange[1].name) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[1].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_per_hour_change))))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[1].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green",
      "margin-left": "10px"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red",
      "margin-left": "10px"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_change))))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.mostImportantFirst.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.mostImportantFirst.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Udviklingen i DB / DB pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.mostImportantColumns,
      "rows": _vm.data.most_important.table.values,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.mostImportantSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_progress_percent === 0 || props.row.coverage_progress_percent > -5 && props.row.coverage_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_per_hour.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_per_hour_progress_percent === 0 || props.row.coverage_per_hour_progress_percent > -5 && props.row.coverage_per_hour_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'coverage_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour_total) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour_total < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.coverage_per_hour_total)) + " \n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsLearning', 'projectTypeGraphs')
      }
    }
  }, [_vm._v("\n                Gå til udviklingen i DB / DB pr. time →\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("DB pr. time")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Samlet DB")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a7db3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PossibleEfforts/projects.vue
// module id = 868
// module chunks = 0